export function getUserStateIdFromSidebar(sidebarData) {
  const profile = sidebarData?.user_data || {};
  const selectedState = sidebarData?.selected_state || {};

  return Number(
    profile?.state_id ||
      profile?.user_state_id ||
      selectedState?.state_id ||
      0
  );
}

export function getUserStateNameFromSidebar(sidebarData) {
  const profile = sidebarData?.user_data || {};
  const selectedState = sidebarData?.selected_state || {};

  return (
    profile?.state_name ||
    profile?.user_state_name ||
    selectedState?.state_name ||
    ""
  );
}

export function resolveQuestionBankStateId({
  locationState,
  requestParams,
  sidebarData,
  fallbackStateId = 0,
} = {}) {
  return Number(
    locationState?.selectedState?.state_id ||
      locationState?.state_id ||
      requestParams?.states_id ||
      requestParams?.state_id ||
      getUserStateIdFromSidebar(sidebarData) ||
      fallbackStateId
  );
}

export function resolveQuestionBankStateName({
  locationState,
  requestParams,
  sidebarData,
  fallbackStateName = "",
} = {}) {
  return (
    locationState?.selectedState?.state_name ||
    locationState?.state_name ||
    requestParams?.state_name ||
    getUserStateNameFromSidebar(sidebarData) ||
    fallbackStateName
  );
}
